import { getBrandedSuccessAnimationData } from "@/lib/branded-success-lottie";
import { useLoaderData } from "@tanstack/react-router";
import { useMemo } from "react";
import Lottie from "react-lottie";
import type { LottieProps, Options } from "react-lottie";

export type BrandedSuccessLottieProps = Omit<LottieProps, "options"> & {
	loop?: boolean;
	autoplay?: boolean;
	rendererSettings?: Options["rendererSettings"];
	/** Defaults to `primary_color` from the root location loader */
	primaryColor?: string;
};

/**
 * Success checkmark Lottie tinted with the white-label primary color from the root loader.
 */
export default function BrandedSuccessLottie({
	loop = false,
	autoplay = true,
	rendererSettings,
	primaryColor,
	...lottieProps
}: BrandedSuccessLottieProps) {
	const { primary_color } = useLoaderData({ from: "__root__" });
	const color = primaryColor ?? primary_color;

	const options = useMemo(
		() =>
			({
				loop,
				autoplay,
				animationData: getBrandedSuccessAnimationData(color),
				...(rendererSettings ? { rendererSettings } : {}),
			}) satisfies Options,
		[loop, autoplay, color, rendererSettings],
	);

	return <Lottie options={options} {...lottieProps} />;
}
